module.exports = {"TXTWCL_Deposit_Funds":{"id":"TXTWCL_Deposit_Funds","defaultMessage":"Guthaben einzahlen","track":"Deposit Funds"}}